import React from 'react';
import PropTypes from 'prop-types';
import BasicPageHeader from 'components/admin/basic/BasicPageHeader';
import ResultTitle from 'components/admin/result/ResultTitle';
import ClubRecord from 'components/admin/result/ClubRecord';
import AgeResultsHelp from 'components/admin/result/AgeResultsHelp';

const AgeResultPageHeader = ({
  title,
  suffix,
  viewLabel,
  clubRecords,
  eventType,
  meet,
}) => {
  return (
    <BasicPageHeader
      leftChild={
        <>
          <ResultTitle title={title} suffix={suffix} viewLabel={viewLabel} />
          <ClubRecord clubRecords={clubRecords} eventType={eventType} />
        </>
      }
      rightChild={<AgeResultsHelp isMultiClub={meet?.meetType === 2} />}
      rightContainerStyle={{ alignSelf: 'flex-start' }}
    ></BasicPageHeader>
  );
};

AgeResultPageHeader.propTypes = {
  title: PropTypes.string,
  suffix: PropTypes.string,
  viewLabel: PropTypes.string,
  clubRecords: PropTypes.arrayOf(PropTypes.object),
  eventType: PropTypes.string,
  meet: PropTypes.object,
};

export default AgeResultPageHeader;
